module.exports = __webpack_public_path__ + "img/slide13.3c7184bf.png";